import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, Legend,
} from "recharts";

const COLORS = ["#D4AF37", "#10B981", "#3B82F6", "#F97316", "#8B5CF6", "#94A3B8"];

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/overview").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-muted-foreground text-sm">Loading…</div>;

  const k = data.kpis;

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <div className="overline mb-2">— Analytics</div>
        <h1 className="font-display text-4xl tracking-tight leading-none">Reports</h1>
        <p className="text-muted-foreground text-sm mt-2">Performance, conversion and pipeline health.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          ["Win rate", `${k.win_rate}%`],
          ["Deals won", k.leads_won],
          ["Deals lost", k.leads_lost],
          ["Active clients", k.active_clients],
        ].map(([l, v]) => (
          <div key={l} className="rounded-xl border border-border bg-card p-5">
            <div className="overline">{l}</div>
            <div className="font-display text-3xl tracking-tight leading-none mt-3">{v}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="rounded-xl border border-border bg-card p-6">
          <div className="overline mb-1">Pipeline value</div>
          <h2 className="font-display text-xl tracking-tight mb-4">By stage</h2>
          <div className="h-72">
            <ResponsiveContainer>
              <BarChart data={data.pipeline}>
                <XAxis dataKey="stage" tick={{ fontSize: 11, fill: "currentColor" }} stroke="hsl(var(--border))" />
                <YAxis tick={{ fontSize: 11, fill: "currentColor" }} stroke="hsl(var(--border))" />
                <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }} />
                <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                  {data.pipeline.map((p, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="rounded-xl border border-border bg-card p-6">
          <div className="overline mb-1">Lead count</div>
          <h2 className="font-display text-xl tracking-tight mb-4">By stage</h2>
          <div className="h-72">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={data.pipeline} dataKey="count" nameKey="stage" innerRadius={60} outerRadius={95} paddingAngle={3}>
                  {data.pipeline.map((p, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
                <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
